import TemplateView from '../../TemplateView'
import messageResource from '../../messageResource'
import {taskNameLower} from '../../util/pluralizeUtils'

export default class TotalWorkAssignments extends TemplateView {
    constructor({
        hasEnterTTRight = false,
        allWorkAssignments = false,
        nTasks = 0,
    }) {
        super()

        this.params = {
            hasEnterTTRight,
            allWorkAssignments,
            nTasks,
        }
    }

    templateHtml() {
        return '<div class="totalWorkAssignments">' +
               '    <span class="label"></span>' +
               '    <span class="nTasks"></span>' +
               '</div>'
    }

    afterRender() {
        this._updateLabel()
        this._updateNTasksText()
    }

    _updateLabel() {
        let labelText
        if (!this.params.hasEnterTTRight)
            labelText = messageResource.getMessage('profile.work_assignments.cant_enter_tt')
        else if (this.params.allWorkAssignments)
            labelText = messageResource.getMessage('profile.work_assignments.can_enter_tt_all')
        else
            labelText = messageResource.getMessage('profile.work_assignments.can_enter_tt')

        this.find('.label').text(labelText)
    }

    _updateNTasksText() {
        const nTasks = this.params.nTasks
        const $taskLabel = this.find('.nTasks')
        if (this.params.allWorkAssignments || !this.params.hasEnterTTRight) {
            $taskLabel.hide()
        } else {
            $taskLabel.text(` ${nTasks} ${taskNameLower(nTasks)}`)
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/userProfile/components/TotalWorkAssignments.js